import { render, staticRenderFns } from "./PackageNameEdit.vue?vue&type=template&id=af69c738&scoped=true"
import script from "./PackageNameEdit.vue?vue&type=script&lang=js"
export * from "./PackageNameEdit.vue?vue&type=script&lang=js"
import style0 from "./PackageNameEdit.vue?vue&type=style&index=0&id=af69c738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af69c738",
  null
  
)

export default component.exports